import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import { Detail } from 'shared/atoms'
import type { Option } from 'shared/components/ContextMenu/types'
import { useRentalDetails } from '../../hooks/useRentalDetails'
import type { RentalItem } from '../../types/rentals.types'

export type RentalProps = {
	rental: RentalItem
	menuOptions: Option[]
}

export const Rental = ({ rental, menuOptions }: RentalProps) => {
	const { t } = useTranslation()
	const getDetails = useRentalDetails()
	const details = getDetails(rental)

	return (
		<li className="p-4">
			<div className="flex items-start justify-between gap-3">
				<p className="min-w-0 text-[13px] font-semibold text-foreground">{details.name}</p>
				<ContextMenu
					dataId={rental.id}
					item={rental}
					options={menuOptions}
					label={t('Actions for {{ name }}', { name: details.name })}
				/>
			</div>
			<dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2 text-[11px]">
				<Detail label={t('Area type')} value={details.boothType} />
				<Detail label={t('Period')} value={details.period} />
				<Detail label={t('Price')} value={details.price} />
				<Detail label={t('Fee')} value={details.fee} />
			</dl>
		</li>
	)
}
